<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('listeMoisComptable.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button
              :class="{'button-access-no-permission':
                !checkPermissions(permissions.maj)}"
              @click="$router.push({name: 'm.presse.mois_comptable-add'})"
              class="button is-addOrEdit">
              {{ $t('listeMoisComptable.actions.add') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              :options="[]"
              :placeholder='$t("general.placeHolder.groupedAction")'
              :elementsSelectionnes="false"
              titleButton="general.button.apply">
            </selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class="column is-5 pdl-0 pdr-0">
            <b-input
              v-model="allCriteresRecherche.auto"
              :placeholder="$t('listeParution.actions.search')"
              type="search" icon="magnify">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click="setShowFiltre">
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label
                  :class="nombreCritere > 0 ? '' : 'is-invisible'"
                  class="has-text-weight-bold">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span
              @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right">
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      :columns="columns"
      :options="options"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable" url=""
      v-if="startArrayRendering">
      <div slot="dateDebut" slot-scope="props">
        <router-link :to="{
          name: 'c.presse.mois_comptable',
          params: { id: props.row.id } }" class="lien"
                     :class="{'text-access-no-permission': !checkPermissions(permissions.maj)}">
          {{ props.row.dateDebut | formatDate }}
        </router-link>
      </div>
      <div slot="dateFin" slot-scope="props">
        {{ props.row.dateFin | formatDate }}
      </div>
      <div slot="edit" slot-scope="props">
        <router-link :to="{
          name: 'm.presse.mois_comptable-edit',
          params: { id: props.row.id } }">
          <b-icon
            :class="{'text-access-no-permission': !checkPermissions(permissions.maj)}"
            icon="pencil-box-outline" type="is-success">
          </b-icon>
        </router-link>
      </div>
      <div slot="archiver" slot-scope="props">
        <div
          @click="checkPermissions(permissions.supprimer) ? inProgress() : showPopUpPermission()"
          class="is-cursor-pointer">
          <b-icon
            :icon="!props.row.archive ? 'archive' : 'archive-arrow-up'"
            :class="{'text-access-no-permission': !checkPermissions(permissions.supprimer)}"
            type="is-default">
          </b-icon>
        </div>
      </div>
      <div slot="delete">
        <div
          class="is-cursor-pointer"
          @click="checkPermissions(permissions.supprimer) ? inProgress() : showPopUpPermission()">
          <b-icon
            :class="{'text-access-no-permission': !checkPermissions(permissions.supprimer)}"
            type="is-danger" icon="delete-forever">
          </b-icon>
        </div>
      </div>
      <template slot="afterTable">
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
    </v-server-table>
    <div v-show="showFiltre" class="componentBrief">
      <filtre-mois-comptable
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter"
        ref="filtreMoisComptable"/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import TableItemsInView from '@/components/general/TableItemsInView';
import filtreMoisComptable from '@/components/presse/moisComptable/filtreMoisComptable';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
} from '@/configuration/clientTableConf';
import inProgress from '@/services/general/inProgress';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import formatIsoDate from '@/services/general/formatIsoDate';
import { MOIS_COMPTABLE } from '@/configuration/presse/permissionsPresseConf';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import selecteurAction from '@/components/general/selecteurAction';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_MOIS_COMPTABLE } from '@/configuration/general/referenceTableConf';

const Permissions = createNamespacedHelpers('permissions');
const MoisComptable = createNamespacedHelpers('moisComptable');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'l_moisComptable',
  components: {
    breadcrumb,
    TableItemsInView,
    filtreMoisComptable,
    selecteurAction,
    parametrageTable,
  },
  data() {
    return {
      permissions: MOIS_COMPTABLE,
      unsubscribeValue: null,
      showFiltre: false,
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_MOIS_COMPTABLE,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...MoisComptable.mapGetters({
      items: 'items',
      total: 'total',
      allCriteresRecherche: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      lockMenu: 'lockMenu',
    }),
    breadcrumb() {
      return [
        { title: this.$t('listeMoisComptable.breadcrumb.home'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeMoisComptable.breadcrumb.liste'), route: { name: 'l.presse.mois_comptable' }, isActive: true },
      ];
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'periode'];
      let nbCritere = calculNombreCritere(this.allCriteresRecherche, banCritereKey);
      if (this.allCriteresRecherche.periode.dateDebut
        || this.allCriteresRecherche.periode.dateFin) nbCritere += 1;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateDebut: this.$i18n.t('listeMoisComptable.tab.dateDebut'),
          dateFin: this.$i18n.t('listeMoisComptable.tab.dateFin'),
          etat: this.$i18n.t('listeMoisComptable.tab.etat'),
          'exerciceComptable.code': this.$i18n.t('listeMoisComptable.tab.exerciceComptable'),
          edit: '',
          archiver: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.allCriteresRecherche);
          if (data.query.etats.length) {
            data.query.etats = data.query.etats.map(el => el.value);
          }
          if (data.query.exercices.length) {
            data.query.exerciceComptableIds = data.query.exercices
              .map(e => e.id);
            delete data.query.exercices;
          }
          data.query.periode = {
            dateDebut: formatIsoDate(data.query.periode.dateDebut),
            dateFin: formatIsoDate(data.query.periode.dateFin),
          };
          return this.actionLoadItems(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.total,
          };
        }),
        columnsClasses: {
          view: 'colonneSelected',
          edit: 'colonneSelected',
          archiver: 'colonneSelected',
          delete: 'colonneSelected',
        },
        sortable: ['exerciceComptable.code', 'dateDebut', 'dateFin', 'etat'],
      };
    },
    columns() {
      return ['dateDebut', 'dateFin', 'exerciceComptable.code', 'etat', 'edit', 'archiver', 'delete'];
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    ...MoisComptable.mapActions({
      actionLoadItems: 'loadItems',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) this.$refs.filtreMoisComptable.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreMoisComptable.initializeFiltre();
      this.$refs.filtreMoisComptable.viderCritere();
      this.$refs.filtreMoisComptable.appliquerCritere();
      this.showFiltre = false;
    },
    inProgress() {
      inProgress(this.$i18n);
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pagePresse.moisComptable.liste'));
  },
};
</script>
